// src/pages/Partners/index.tsx 
import { Button, Flex } from '@chakra-ui/react';
import FeatherIcon from '@ailibs/feather-react-ts';
import { PageContent } from '@/components/PageContent';
import { partnersBreadcrumb } from './breadcrumb';
import { PartnersSection } from './components/PartnersSection/PartnersSection';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const Partners = () => {
  const { t } = useTranslation();
  const [isShowCreateModal, setIsShowCreateModal] = useState<boolean>(false);

  return (
    <PageContent
      title={t('pages.partners.partners_title')}
      actionsContent={
        <Flex gap={4} direction={{ base: 'column', md: 'row' }} w='100%'>
          <Button
            display='flex'
            alignItems='center'
            gap={2}
            onClick={() => setIsShowCreateModal(true)}
            width={{ base: '100%', md: 'initial' }}
          >
            <FeatherIcon name='plus-circle' />
            {t('pages.partners.partners_add_partner_button')}
          </Button>
        </Flex>
      }
      breadcrumbItems={partnersBreadcrumb}
    >
      <PartnersSection isShowCreateModal={isShowCreateModal} setIsShowCreateModal={setIsShowCreateModal} />
    </PageContent>
  );
};
